// extracted by mini-css-extract-plugin
module.exports = {"base":"section-layout_base__WqbeQ","isCentered":"section-layout_isCentered__9uAbc"};